(() => {
  function initialise(root) {
    if (root.dataset.partnerReady) return;
    root.dataset.partnerReady = 'true';
    root.querySelectorAll('[data-partner-open]').forEach(button => {
      const dialog = root.querySelector(`[data-partner-dialog="${button.dataset.partnerOpen}"]`);
      if (!dialog) return;
      button.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-partner-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => button.focus());
    });
  }
  document.querySelectorAll('[data-partner-network]').forEach(initialise);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-partner-network]').forEach(initialise));
})();
